import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";

@Component({ name: "EventToolTestRideBooking" })
export default class EventToolTestRideBooking extends Vue {
    public isLoadingForm: boolean = false;
    public isDeleted: boolean = false;
    public validationErrors: any[] = [];

    @Prop() readonly registrationToken: string;
    @Prop() readonly email: string;
    @Prop() readonly status: string;
    @Prop() readonly isSlot: boolean;

    get routes() {
        return (<any>window).App.routes;
    }

    public async submitConfimForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoadingForm = true;

        try {
            await Axios.post(this.routes.EventToolTestRideBooking_Confirm, { registrationToken: this.registrationToken, email: this.email });

            document.querySelector(".app-page.manage").classList.add("hden");
            document.querySelector(".app-page.confirmed").classList.remove("hden");
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoadingForm = false;
    }

    public confirmCancelledForm() {
        if (window.confirm("Sei sicuro di voler procedere con l'eliminazione della prenotazione?")) {
            this.submitCancelledForm();
        }
    }

    public async submitCancelledForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoadingForm = true;

        try {
            await Axios.post(this.routes.EventToolTestRideBooking_Cancel, { registrationToken: this.registrationToken, email: this.email });

            this.isDeleted = true;

            document.querySelector(".app-page.manage").classList.add("hden");
            document.querySelector(".app-page.cancelled").classList.remove("hden");
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoadingForm = false;
    }

    public openDialog() {
        this.$store.commit("eventToolStore/setIsRegistrationVisible", true);
    }
}